/**
 * MOCK EMAIL SERVICE
 * 
 * TODO: Replace this function with a real email service implementation (e.g., EmailJS, SendGrid, or a backend endpoint).
 * Currently, this function simulates a successful email transmission with a 90% success rate.
 * 
 * @param {Object} formData - The data from the contact form.
 * @returns {Promise<{success: boolean, message: string}>}
 * @throws {Error} If the simulated random failure occurs.
 */
export async function sendEmail(formData) {
  // Simulación de envío de email
  // En producción, aquí integrarías con EmailJS, SendGrid, o tu backend
  console.log('Enviando email con datos:', formData);

  // Simular delay de red
  await new Promise(resolve => setTimeout(resolve, 1000));

  // Simular éxito (en producción manejarías errores reales)
  if (Math.random() > 0.1) { // 90% de éxito
    return { success: true, message: 'Email enviado correctamente' };
  } else {
    throw new Error('Error al enviar el email');
  }
}
